module.exports = __webpack_public_path__ + "static/media/customer.0c1abecd.md";